import { Typography } from "@mui/material"
import { Box } from "@mui/system"

const Patrocinadores = () => {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <img src="/images/patrocinadores.jpg" width='70%' />
        </Box>
    )
}

export default Patrocinadores